import { formatDate } from 'date-fns';
/**
 * Converts date to *string* in format like '2024-06-17'.
 *
 * Intended to use inside `api`'s.
 */
export function convertDateToDateOnlyString(date) {
    return formatDate(date, 'yyyy-MM-dd');
}
